import PaystackPop from "@paystack/inline-js";

export function payWithPaystack({
  email,
  amount,
  reference,
  metadata,
  onSuccess,
  onClose
}) {
  const paystack = new PaystackPop();

  paystack.newTransaction({
    key: process.env.REACT_APP_PAYSTACK_PUBLIC_KEY,
    email,
    amount: amount * 100, // Paystack uses kobo
    reference,
    metadata,

    onSuccess: (transaction) => {
      onSuccess?.(transaction);
    },

    onCancel: () => {
      onClose?.();
    }
  });
}